export enum NOTECARDS_PDP_FLOW_TEST {
  Control = 'NoteCardsPDPFlowTestControl',
}

export const NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME = 'note_cards_pdp_vs_dff'
